// NATIVE

// INSTALLED

// CUSTOM
import { useDispatch } from 'react-redux';
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getAllNovedadesTurnoService = async () => {
  try {
    return await http.get<any>(`/v1/news`);
  } catch (error: any) {
    console.log('getAllNovedadesTurnoService ', error);

    if (error && !error.ok) {
      return error;
    }
    console.log('getAllNovedadesTurnoService ', error);
  }
};

export const getNovedadesTurnoDataCreateService = async () => {
  try {
    return await http.get<any>(`/v1/news/data-create-form-inputs`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getNovedadesTurnoDataCreateService ', error);
  }
};

export const createNovedadesTurnoService = async (
  tipoNovedad: object,
  setPercentajeCreateTurno: any
) => {
  try {
    return await http.post<any>(`/v1/news`, tipoNovedad, setPercentajeCreateTurno);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createTipoNovedadService ', error);
  }
};

export const desactiveNovedadesTurnoService = async (novedadadesTurnoId: string) => {
  try {
    return await http.delete<any>(`/v1/news/${novedadadesTurnoId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('desactiveNovedadesTurnoService ', error);
  }
};

export const activeNovedadTurnoService = async (novedadadesTurnoId: string) => {
  try {
    return await http.patch<any>(`/v1/news/${novedadadesTurnoId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('activeNovedadTurnoService ', error);
  }
};

export const getNovedadTurnoDetailService = async (novedadadesTurnoId: string) => {
  try {
    return await http.get<any>(`/v1/news/${novedadadesTurnoId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getNovedadTurnoDetailService ', error);
  }
};

export const getNovedadTurnoDetailEditService = async (novedadadesTurnoId: string) => {
  try {
    return await http.get<any>(`/v1/news/edit/${novedadadesTurnoId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getNovedadTurnoDetailEditService ', error);
  }
};

export const getAllTipoNovedadesByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/news?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAllTipoNovedadesByPaginateService ', error);
  }
};

export const updateNovedadTurnoService = async (tipoNovedad: object) => {
  try {
    return await http.put<any>(`/v1/news`, tipoNovedad);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateNovedadTurnoService ', error);
  }
};
